import styled from 'styled-components'

import { palette } from '../../../../theme/palette'

export const ModalWrapper = styled.div.attrs(() => ({
  'data-test': 'webview-container'
}))`
  margin: auto;
  width: 100%;
  height: 100%;
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: calc(100vh - 100px);
  padding: 0 10px 32px 0;

  @media screen and (max-width: 321px) {
    padding: 0 10px 16px 0;
  }
`

export const ModalHeader = styled.div`
  width: 100%;
  height: 32px;
`

export const ModalContent = styled.div<{ isDobContent?: boolean, isLoading?: boolean }>`
  background: ${palette.white};
  overflow-y: auto;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 12px;
  padding: ${({ isDobContent }) => isDobContent ? '0 22px 24px 32px': '0 22px 0 32px'};
  font-size: 17px;
  line-height: 20px;
  display: ${props => props.isLoading ? 'none' : 'block'};
  
  &::-webkit-scrollbar {
    width: 6px;
  }

  @media screen and (max-width: 391px) {
    padding: ${({ isDobContent }) => isDobContent ? '0 6px 24px 16px' : '0 22px 0 32px'}
  }

  @media screen and (max-width: 360px) {
    padding: ${({ isDobContent }) => isDobContent ? '0 6px 24px 16px' : '0 6px 0 16px'}
  }
`

export const WebViewImage = styled.img<{ isNeedMargin: boolean }>`
  max-width: 100%;
  border: 1px solid ${palette.lightBlue};
  box-sizing: border-box;
  border-radius: 10px;
  margin-bottom: ${({ isNeedMargin }) => isNeedMargin ? 24 : 0}px;
`

export const WebViewText = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: ${palette.mainText};
  margin: 0;
  
  & h1 {
    margin: 0 0 16px;
    line-height: 100%;
    font-size: 24px;
  }
  
  & ul {
    margin: 0;
    padding-left: 26px;
  }
`

export const LoaderContainer = styled.div`
  height: 286px;
`

export const CloseButtonContainer = styled.button.attrs(() => ({
  'data-test': 'webview-close'
}))`
  position: absolute;
  top: 13px;
  right: 13px;
  cursor: pointer;
  background-color: ${palette.transparent};
  padding: 0;
  border: none;
  
  & svg {
    display: block;
  }
  
  &:focus-visible {
    outline: 2px solid ${palette.mainBlue};
  }
`

export const ModalTitle = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${palette.mainText};
  margin: 0 0 24px 32px;

  @media screen and (max-width: 391px) {
    margin: 0 0 24px 16px;
  }
`

export const ModalFooter = styled.div<{ isDobContent: boolean }>`
  padding: ${({ isDobContent }) => isDobContent ? '0' : '0 0 22px'};
  margin: 0 12px 0 22px;
  box-shadow: 0px -16px 8px ${palette.white};

  @media screen and (max-width: 391px) {
    margin: 0 -4px 0 6px;
  }
`
